import React from 'react';
import { makeStyles } from '@material-ui/core';
import loader from '../assets/loader.gif';

const useStyles = makeStyles(() => ({
    root: {
        width: "100%",
        textAlign: "center",
        margin: '64px 0'
    },
}));

const LoadingIndicator = (props) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <img style={{ width: '65px', height: '65px' }} alt="loader" src={loader} />
        </div>
    )
}

export default LoadingIndicator;